import { QuestionOrder, QuestionText } from "./Question.style";

interface Props {
    question: string;
    order: number;
}

export default function Question({ question, order }: Props) {

    const formatOrder = (value: number) => {
        const normalizedValue = Math.abs(Math.trunc(value));

        if (normalizedValue < 10) {
            return `0${normalizedValue}`;
        }

        return normalizedValue.toString();
    };

    return(
        <>
            <QuestionOrder>{formatOrder(order)}</QuestionOrder>
            <QuestionText>{question}</QuestionText>
        </>
    )
}